var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lcly-button-0"}},[_c('a',{attrs:{"id":"lcly-link-0","href":"https://brands.locally.com","target":"_blank"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.bp('locallyLink'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }